export enum FieldSource {
  Unknown = 'Unknown',
  Sender = 'Sender',
  Recipient = 'Recipient',
  Document = 'Document',
}
